module.exports = __webpack_public_path__ + "img/gogol.d0c92b12.jpg";